module.exports = __webpack_public_path__ + "static/media/70e65090-e488-440c-98bd-fa829b84adc9.b6904172.JPG";